import feature from "./feature.vue";
import register from "./store";

export default feature;
export {
    register
}
